@import 'styles/mixins';
@import 'styles/variables';

.styledButton {
  width: auto;
  min-width: 40px;
  height: 40px;
  padding: 10px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  [data-autopilot-system-redesign='on'] & {
    height: 32px;
    min-width: 32px;
    border-radius: 8px;
    padding: 8px;
  }
}

.softButton {
  padding: 0.5em;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.softButton,
.button {
  user-select: none;
  color: var(--dark-100);
  cursor: pointer;

  &:hover {
    background: var(--dark-4);
    box-shadow: 0px 5px 10px 0px var(--light-5);
  }

  &.buttonDisabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.5;

    &:hover {
      background: none;
    }
  }

  &:focus-visible,
  &:focus,
  &:active {
    outline: none;
  }

  &.focused {
    transition: none;
    box-shadow: inset 0 0 0 2px var(--dark-20);
    outline: none;
  }
}

.buttonSelected {
  background: linear-gradient(0deg, var(--dark-7) 0%, var(--dark-7) 100%), var(--dark-7);

  [data-autopilot-system-redesign='on'] & {
    background: var(--dark-80);
    color: var(--light-100);
  }

  &:hover {
    background: var(--dark-4);
    box-shadow: 0px 5px 10px 0px var(--dark-5);
    color: var(--neutral-40);
  }
}

.buttonActive {
  background: var(--selected-fill);
  color: var(--light-100);

  &:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.05) 100%), var(--selected-fill);
  }
}

.buttonSelected {
  background: var(--focus-5);
}

.button {
  &.styledButton {
    width: auto;
    min-width: 40px;
    height: 40px;
    padding: 10px;
    border-radius: 20px;

    [data-autopilot-system-redesign='on'] & {
      height: 32px;
      min-width: 32px;
      border-radius: 8px;
      padding: 8px;
    }
  }
}
